import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import '../styles/SplashPage.css';
import dexLogo from '../assests/DexWallet Logo Symbol.png';

const SplashPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useWallet();

  useEffect(() => {
    // Check if wallet exists after animation completes
    const timer = setTimeout(() => {
      if (isAuthenticated()) {
        navigate('/unlock');
      } else {
        navigate('/welcome');
      }
    }, 2500); // Total animation duration

    return () => clearTimeout(timer);
  }, [navigate, isAuthenticated]);

  return (
    <div className="splash-page">
      <motion.div
        className="splash-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="logo-container"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{
            duration: 0.5,
            ease: "easeOut"
          }}
        >
          <div className="logo-background" />
          <img src={dexLogo} alt="DexWallet Logo" className="logo-icon" />
        </motion.div>

        <motion.div
          className="app-name"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <h1>DexWallet</h1>
        </motion.div>

        <div className="progress-container">
          <motion.div
            className="progress-bar"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              delay: 0.3
            }}
          />
        </div>
      </motion.div>
    </div>
  );
};

export default SplashPage; 